module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "matches"
  }, [_c('header-bar'), _vm._v(" "), _c('section', {
    staticStyle: {
      "margin-top": "100px"
    }
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('h1', [_vm._v("Delete a user:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.userid),
      expression: "userid",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "User UID",
      "required": ""
    },
    domProps: {
      "value": (_vm.userid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userid = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "btn btn-big bg-two active",
    staticStyle: {
      "margin-top": "50px",
      "background-position": "50% 553px"
    },
    attrs: {
      "type": "submit",
      "value": "Delete User"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.deleteUser($event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "grid-container"
  }, [_vm._v("\n    " + _vm._s(_vm.userdata) + "\n    ")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c1db504"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/DeleteUser.vue
// module id = 720
// module chunks = 1